export const JIMDE_DISTRIBUTION_COMPANY_ID = "jimde-services";

function isDistributionAdmin(userData) {
  return (
    userData?.role === "distributionAdmin" ||
    userData?.distributionRole === "admin" ||
    userData?.allowedModules?.includes("distribution")
  );
}

// Moved verbatim from App so discovery follows the established redirect.
export function isLimitedDistributionAdmin(userData) {
  const hasBroaderDashboardAccess =
    userData?.modules?.operations === true ||
    userData?.modules?.finance === true ||
    userData?.modules?.crm === true ||
    userData?.modules?.accounting === true ||
    userData?.modules?.sales === true ||
    userData?.modules?.invoices === true ||
    userData?.modules?.inventory === true ||
    userData?.modules?.productivity === true ||
    userData?.allowedModules?.includes("operations") ||
    userData?.allowedModules?.includes("finance") ||
    userData?.allowedModules?.includes("crm") ||
    userData?.allowedModules?.includes("accounting") ||
    userData?.allowedModules?.includes("sales") ||
    userData?.allowedModules?.includes("invoices") ||
    userData?.allowedModules?.includes("inventory") ||
    userData?.allowedModules?.includes("productivity") ||
    userData?.allowedModules?.includes("all");

  return (
    isDistributionAdmin(userData) &&
    userData?.role !== "owner" &&
    userData?.role !== "admin" &&
    !hasBroaderDashboardAccess
  );
}

export function isSelennePlatformAdmin(currentUser, userData) {
  const email = (currentUser?.email || "").toLowerCase();

  return (
    email === "mtantonio3@gmail.com" ||
    userData?.role === "platformAdmin" ||
    userData?.role === "superAdmin" ||
    userData?.isPlatformAdmin === true ||
    userData?.isSuperAdmin === true
  );
}

export function canAccessJimdeDistributionModule(currentUser, userData) {
  return (
    userData?.companyId === JIMDE_DISTRIBUTION_COMPANY_ID ||
    isSelennePlatformAdmin(currentUser, userData)
  );
}
